// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__37TD9","content":"styles_content__11Nnk","selectAll":"styles_selectAll__1lg4L"};